export const HBO_STUDIES = {
  'HBO Associate Degree': [
    // Economisch en Bedrijf - Bedrijfskunde & Management
    'Bedrijfskunde',
    'Business Administration',
    'Management',
    'Technische Bedrijfskunde',
    'Technische Bedrijfskunde & IT',
    'International Business',
    'International Business Management',
    'Sustainability',
    'Ondernemerschap & Retail Management',
    'Ondernemen',
    'Business School Notenboom',
    'Bedrijfskunde en Agribusiness',
    // Economisch en Bedrijf - Finance & Accountancy
    'Accountancy',
    'Finance',
    'Finance & Control',
    'Financieel Management',
    'Sociaal Financiële Dienstverlening',
    'Payroll Services',
    // Economisch en Bedrijf - Marketing & Communicatie
    'Online Marketing',
    'Marketing Management',
    'Commerciële Economie',
    'Commerciële Economie & Ondernemerschap',
    'E-commerce',
    'Commercieel Management',
    'Communicatie',
    'Smart Media Production',
    'Online Contentcreator',
    'Crossmediale Communicatie',
    'Creative Media Professional',
    'Digitale Techniek & Media',
    'Media Design',
    // Economisch en Bedrijf - Hospitality, Horeca & Toerisme
    'Horeca Management',
    'Hotel Management',
    'International Hospitality Management',
    'Hotel & Event Management',
    'Tourism Management',
    'Internationaal Toeristisch Management',
    'Leisure & Event Management',
    'Leisure & Events Management',
    // Economisch en Bedrijf - Logistiek & Supply Chain
    'Logistics & Supply Chain Management',
    'Supply Chain Management',
    'Logistiek',
    'Logistiek Management',
    // Economisch en Bedrijf - Human Resources & Organisatie
    'Human Resource Management',
    'Officemanagement',
    'Facilitair Eventmanagement',
    'Facility Management',
    // Economisch en Bedrijf - Sales & Retail
    'Sales en Accountmanagement',
    'Ondernemerschap & Retail Management',
    // Economisch en Bedrijf - Food & Fashion Business
    'Food, Business & Innovation',
    'Fashion Business Professional',
    // Onderwijs & Pedagogiek - Educatie & Didactiek
    'Educatief Professional Beroepsonderwijs',
    'Pedagogisch Educatief Professional',
    'Didactisch Educatief Professional',
    // Onderwijs & Pedagogiek - Onderwijs & Ondersteuning
    'Onderwijsondersteuner Gezondheidszorg en Welzijn',
    'Onderwijsondersteuner Consumptieve Techniek I en II',
    'Onderwijsondersteuner Omgangskunde',
    'Onderwijsondersteuner Technisch Beroepsonderwijs',
    'Schrijftolk',
    'Kinderopvang',
    // Design & Kunst - Design & Interieur
    'Design',
    'Interior Brand Identity',
    'Interieurvormgever',
    // Design & Kunst - Creatieve Kunsten
    'Arts & Crafts',
    // Gezondheid & Zorg - Zorg & Welzijn
    'Management in de Zorg',
    'Zorg en Technologie',
    'Praktijkondersteuner Huisarts',
    'Ervaringsdeskundigheid in Zorg en Welzijn',
    // Gezondheid & Zorg - Zorg & Veiligheid
    'Zorg & Veiligheid',
    // Exact & Informatica - Software & Development
    'Software Development',
    'Frontend Design & Development',
    // Exact & Informatica - Cybersecurity & IT Management
    'Cybersecurity',
    'Cyber Safety & Security',
    'Information Security',
    'IT Service Management',
    'ICT Service Management',
    // Exact & Informatica - ICT & Data
    'ICT & Telecommunicatie',
    'ICT-Engineer',
    'AD-ICT',
    'Informatica',
    'ICT Internet of Things',
    'Data Analytics',
    'ICT',
    // Techniek & Bouw - Engineering & Mechatronica
    'Engineering',
    'Werktuigbouwkunde',
    'Mechatronica',
    'Mechatronica in de Smart Industry',
    'Embedded Systems Engineering',
    // Techniek & Bouw - Bouw & Constructie
    'Bouwkunde',
    'Bouwtechnisch Medewerker',
    'Integraal Bouwmanagement',
    'Civiele Techniek Projectvoorbereiding en Realisatie',
    'Built Environment',
    'Bouwmanagement',
    // Techniek & Bouw - Installatie & Onderhoud
    'Gebouwgebonden Installatietechniek',
    'Maintenance',
    'Smart Asset Maintenance',
    // Techniek & Bouw - Energietransitie & Duurzaamheid
    'Energietransitie Engineer',
    // Techniek & Bouw - Automatisering & Robotica
    'Industriële Automatisering en Robotica',
    'Industriële Automatisering',
    // Techniek & Bouw - Transport & Maritiem
    'Maritieme Techniek',
    'Automotive',
    // Gedrag & Maatschappij - Sociaal Werk & Participatie
    'Sociaal Werk',
    'Participatie en Buurtontwikkeling',
    'Ervaringsdeskundigheid in Zorg en Welzijn',
    // Gedrag & Maatschappij - Jeugd & Sport
    'Sport',
    'Jeugdwerker',
    // Recht & Bestuur
    'Juridisch Medewerker',
    'Rechten',
    // Aarde & Milieu - Voedsel & Landbouw
    'Tuinbouwmanagement',
    'Dier- en Veehouderij',
    'Tuinbouw en Akkerbouw',
    'Melkveehouderij',
    'Voedingsmiddelentechnologie',
    // Aarde & Milieu - Natuur & Landschap
    'Tuin- en Landschapsinrichting',
    'Land- en Watermanagement',
    'Groene Leefomgeving',
    'Omgevingskunde',
    // Aarde & Milieu - Milieu & Educatie
    'Educatie en Kennismanagement Groene Sector',
    // Aarde & Milieu - Creatieve Groenvoorziening
    'Bloemsierkunst',
    // Aarde & Milieu - Culinary & Voeding
    'Culinary Professional'
  ],
  'HBO Bachelor': [
    // Economie & Bedrijfskunde - Financiën & Accountancy
    'Accountancy',
    'Finance & Control',
    'Finance, Tax and Advice',
    'International Financial Management en Control',
    'Master of Financial Management and Control',
    'Social Financiële Dienstverlening',
    // Economie & Bedrijfskunde - Bedrijfskunde & Management
    'Bedrijfskunde',
    'Business Administration',
    'Ondernemerschap en Retail Management',
    'Risicomanagement',
    'Vastgoedkunde',
    // Economie & Bedrijfskunde - Marketing & Commercie
    'Commerciële Economie',
    'E-Commerce',
    'Online Marketing',
    'Sales en Accountmanagement',
    'Crossmediale communicatie',
    // Management & Organisatie - Algemeen Management
    'Management en Organisatie',
    'Business Administration',
    'Master Begeleidingskunde',
    'Master Management en Innovatie in Maatschappelijke Organisaties',
    // Management & Organisatie - Ondernemerschap & Innovatie
    'Business Innovation (EN)',
    'Creative Business',
    'Ondernemerschap Retail and Management',
    // Management & Organisatie - Human Resource & Coaching
    'Human Resource Management',
    'Organisatiecoaching',
    // Management & Organisatie - Facility & Veiligheid
    'Facility Management',
    'Facilitair Eventmanagement',
    'Integrale Bedrijfsvoering',
    'Integrale Veiligheidskunde',
    'Safety and Security Management Studies',
    // Management & Organisatie - Internationaal & Logistiek
    'AMSIB - International Business',
    'European Studies',
    'Shipping and Transport',
    // Techniek & ICT - Engineering & Technologie
    'Automotive',
    'Automotive Engineering',
    'Maritiem Officier',
    'Biomedische Technologie',
    'Mens en Techniek',
    'Built Environment',
    'Civiele Techniek',
    'Stedenbouw',
    'Ruimtelijke Ontwikkeling',
    'Chemische Technologie',
    'Process en Food Technology',
    'Elektrotechniek',
    'Engineering: Elektrotechniek',
    'Smart Technology',
    'Engineering',
    'Engineering: Technische Bedrijfskunde',
    'Engineering: Werktuigbouwkunde',
    'Next Level Engineering',
    'Industrial Design Engineering',
    'Industrial Engineering and Management',
    'Mechatronica',
    'Technische Natuurkunde',
    'Toegepaste Wiskunde',
    'Engineering: Product Ontwerpen',
    'Artificial Intelligence',
    // Techniek & ICT - Informatica & Cybersecurity
    'Cyber Security Engineering',
    'Cybersecurity',
    'HBO-ICT',
    'Informatica',
    'Information Security',
    'Information Technology',
    'IT Service Management',
    'Artificial Intelligence',
    // Techniek & ICT - Supply Chain & Bouwmanagement
    'Integraal Bouwmanagement',
    'International Supply Chain Management',
    'Logistics Engineering',
    'Logistics Management',
    'Maintenance',
    // Techniek & ICT - Luchtvaart & Transport
    'Aviation',
    'Luchtvaarttechnologie',
    // Gezondheid & Zorg - Medische Zorg & Therapie
    'Ergotherapie',
    'Ergotherapie: Leerroute IPZ',
    'Fysiotherapie',
    'Fysiotherapie: Leerroute IPZ',
    'Huidtherapie',
    'Physician Assistant',
    'Podotherapie',
    'Verloskunde',
    // Gezondheid & Zorg - Gezondheid & Voeding
    'Advanced Health Informatics Practice',
    'Food Commerce & Technology',
    'Gezondheid',
    'Management in de Zorg',
    'Medical Imaging and Radiation Therapy',
    'Voeding en Diëtetiek',
    // Gezondheid & Zorg - Sociale & Psychische Zorg
    'Interprofessionele Paramedische Zorg',
    'Oefentherapie: Leerroute IPZ',
    'Social Work',
    'Toegepaste Psychologie',
    // Recht & Bestuur - Bestuur & Beleidsvorming
    'Bestuurskunde',
    'European Studies',
    'International Public Policy and Leadership',
    // Recht & Bestuur - Juridische Studies
    'Forensisch Onderzoek',
    'HBO-Rechten',
    'Sociaal Juridische Dienstverlening/Expert',
    // Onderwijs & Opvoeding - Lerarenopleiding - Algemeen
    'Kopopleiding Tweedegraadsleraar',
    'Leraar Aardrijkskunde',
    'Leraar Biologie',
    'Leraar Duits',
    'Leraar Economie',
    'Leraar Engels',
    'Leraar Frans',
    'Leraar Geschiedenis',
    'Leraar Gezondheidszorg en Welzijn',
    'Leraar Horeca en Voeding',
    'Leraar Maatschappijleer',
    'Leraar Natuurkunde',
    'Leraar Nederlands',
    'Leraar Omgangskunde',
    'Leraar Pedagogiek',
    'Leraar Scheikunde',
    'Leraar Spaans',
    'Leraar Technisch Beroepsonderwijs',
    'Leraar Wiskunde',
    // Onderwijs & Opvoeding - Lerarenopleiding - Specifieke Richtingen
    'Academie/Leraar voor Lichamelijke Opvoeding (ALO)',
    'Docent Beeldende Kunst en Vormgeving',
    'Docent Theater',
    'Educatief Professional Beroepsonderwijs',
    'Pabo',
    'Pabo-ALO (Leraar Basisonderwijs)',
    'Pedagogiek',
    'Pedagogisch Educatief Professional',
    'Universitaire Pabo',
    // Onderwijs & Opvoeding - Onderwijs & Innovatie
    'Educational Leadership',
    'Leren Innoveren',
    'Logopedie',
    'Master Jonge Kind',
    'Taalbewust Leren',
    // Media, Communicatie & Creativiteit - Communicatie & Journalistiek
    'Communicatie',
    'Communication and Multimedia Design',
    'International Communication Management',
    'Journalistiek',
    // Media, Communicatie & Creativiteit - Design & Creatieve Sector
    'AMFI - Amsterdam Fashion Institute',
    'Circus and Performance Art',
    'Crossmediale Communicatie',
    'Design – Art, Communication and Design',
    'Electronic Music',
    'Master Design',
    // Media, Communicatie & Creativiteit - Marketing & Sales
    'Marketing Management',
    'Sales en Accountmanagement',
    // Sport & Bewegen - Sportonderwijs & Coaching
    'Academie/Leraar voor Lichamelijke Opvoeding (ALO)',
    'Lesgeven in Sport en Bewegen',
    'Sport Studies',
    'Sportkunde',
    // Sport & Bewegen - Sportmanagement & Marketing
    'Johan Cruyff Academy',
    'SPECO Sportcommunicatie',
    'SPECO Sportmarketing'
  ],
  'HBO Master': [
    // Economie & Bedrijfskunde - Algemeen Management & Strategie
    'Master of Business Management',
    'Master of Strategic Management',
    'Executive MBA',
    'Strategy & Leadership',
    'MBA Leadership in Sustainability',
    'MBA Innovation & Leadership',
    'Master Circulaire Economie',
    'Business Engineering',
    'Interdisciplinary Business Professional',
    'Integraal Adviseur MKB',
    'Intergrale Bedrijfsvoering',
    // Economie & Bedrijfskunde - Ondernemerschap & Innovatie
    'Master in Consultancy and Entrepreneurship',
    'Management and Innovation',
    'Digital Driven Business',
    'Economische Transformatie',
    'Design Driven Innovation',
    'Imagineering, Master in Business Innovation from the Experience Perspective',
    'Applied Sustainability Management',
    'Sustainable Business Transition',
    'Action Learning MBA',
    'Business Sales',
    // Economie & Bedrijfskunde - Financieel Management & Control
    'Master in Controlling',
    'Master of Financial Management and Control',
    'Finance and Control',
    // Economie & Bedrijfskunde - Human Resource Management & Organisatie
    'Organisatie Coaching',
    'Human Resource Management (Master)',
    'Kwaliteitsmanagement',
    'Risico Management',
    // Economie & Bedrijfskunde - Project- & Eventmanagement
    'Project, Programma & Portfolio Management',
    'Projectmanagement',
    'Strategic Events Management',
    // Economie & Bedrijfskunde - Supply Chain & Facility Management
    'International Supply Chain Management',
    'Master in International Supply Chain Management',
    'Facility and Real Estate Management',
    // Economie & Bedrijfskunde - Toerisme, Hospitality & Leisure
    'International Hospitality and Service Management',
    'Leading Hotel Transformation',
    'Master of International Hospitality Management',
    'International Leisure, Tourism & Events Management',
    'Tourism Destination Management',
    // Onderwijs & Opvoeding - Lerarenopleidingen
    'Leraar Geschiedenis',
    'Leraar Nederlands',
    'Leraar Fries',
    'Leraar Biologie',
    'Leraar Algemene Economie',
    'Leraar Wiskunde',
    'Leraar Frans',
    'Leraar Godsdienst',
    'Leraar Engels',
    'Leraar Duits',
    'Leraar Bedrijfseconomie',
    'Leraar Natuurkunde',
    'Leraar Aardrijkskunde',
    'Leraar Scheikunde',
    'Leraar Maatschappijleer',
    // Onderwijs & Opvoeding - Onderwijsinnovatie & -technologie
    'Leren Innoveren',
    'Onderwijs & Technologie',
    'Innovation & Leadership in Education',
    'Ontwerpen van Eigentijds Leren',
    'Toetsdeskundige',
    'Talentontwikkeling en Diversiteit',
    'Master Leiderschap in Onderwijs',
    'Leren en Innoveren',
    'Docent Hoger Gezondheidszorg Onderwijs',
    // Onderwijs & Opvoeding - Onderwijsmanagement & -beleid
    'Educational Leadership',
    'Master Educational Leadership',
    'Master Leiderschap en Innovatie Kind en Educatie',
    'Professioneel Meesterschap',
    'Passend Meesterschap',
    // Onderwijs & Opvoeding - Pedagogiek & Speciaal Onderwijs
    'Educational Needs',
    'Pedagogiek',
    'Taalbewust Leren',
    // Kunst & Cultuur - Beeldende Kunst & Vormgeving
    'Master of Arts in Fine and Design',
    'Master Design',
    'Animatie',
    'Master Scientific Illustration',
    'Interieurarchitectuur',
    'Interior Architecture',
    'Type and Media',
    // Kunst & Cultuur - Podiumkunsten & Muziek
    'Choreografie',
    'Performing Public Space',
    'Operationeel Leiderschap in Performing Arts',
    'Theater',
    'Performance Practices',
    'Opera',
    'Sonologie',
    // Kunst & Cultuur - Media & Creatieve Industrie
    'Film',
    'DAS Creative Producing',
    'Crossover Creativity',
    'Applied Museum and Heritage Studies',
    // Kunst & Cultuur - Filosofie & Theologie
    'Evangelical Theology',
    'Toegepaste Islamitische Theologie',
    'Toegepaste Filosofie',
    // Gezondheid & Zorg - Fysiotherapie & Bewegingszorg
    'Fysiotherapie en Innovatie in Beweegzorg',
    'Orofaciale Fysiotherapie',
    'Sportfysiotherapie',
    'Fysiotherapie en Wijkgerichte Beweegzorg',
    'Master Kinderfysiotherapie',
    'Fysiotherapie in de Geriatrie',
    'Manuele Therapie',
    'Musculoskeletale Revalidatie',
    'Musculoskeletale Echografie voor Fysiotherapeuten',
    'Bekkenfysiotherapie',
    // Gezondheid & Zorg - Verpleegkunde & Gezondheidszorg
    'Advanced Nursing Practice',
    'Verpleegkunde Specialist/ANP GGZ',
    'GGZ-Verpleegkunde (GGZ-V)',
    'Critical Care',
    'Public Health and Health Equity',
    'Physician Assistant',
    // Gezondheid & Zorg - Innovatie & Leiderschap in Zorg
    'Health Innovation',
    'Gezondheidsinnovatie',
    'Innovatie in Zorg en Welzijn',
    'Advanced Health Informatics Practice',
    'Leiderschap voor Persoonsgerichte Zorg en Ondersteuning',
    'Healthy Ageing Professional',
    // Gezondheid & Zorg - Medische & Life Sciences
    'Medical Imaging/Radiation Oncology',
    'Molecular Life Sciences',
    'Neurorevalidatie',
    // Techniek & ICT - ICT & Data Science
    'Management van IT',
    'Informatics',
    'Applied IT',
    'ICT: Software Engineering',
    'Applied Artificial Intelligence',
    'Business Information',
    'Cyber Security Engineering',
    'Responsible AI Innovation',
    'Computer Vision & Data Science',
    'Digital Design',
    'Applied Data Science',
    'Human-Centered Artificial Intelligence',
    'Digital Forensics',
    'Master of ICT and Business Innovation',
    // Techniek & ICT - Engineering & Technologie
    'Polymer Engineering',
    'Master Digitale Technologie',
    'Robotics Systems Engineering',
    'System Design',
    'Next Level Engineering',
    'Applied Nanotechnology',
    'Innovatie Textile Development',
    // Techniek & ICT - Bouw & Infra
    'Architectuur',
    'Stedenbouw',
    'Urban Technology',
    'Constructief Ontwerpen',
    'Master in Structural Engineering',
    'Master of Pipeline Technology',
    // Techniek & ICT - Maritiem & Transport
    'Opleiding tot Registerloods: Master in Maritieme Piloting',
    'Shipping and Transport',
    'Maritime Innovations',
    // Techniek & ICT - Games & Digitale Innovatie
    'Game Technology',
    'Serious Gaming',
    'Data-driven Design',
    // Gedrag & Maatschappij - Psychologie & Coaching
    'Begeleidingskunde',
    'Toegepaste Psychologie voor Professionals',
    'Contextuele Benadering',
    'Speltherapie',
    'Ervaringsdeskundigheid',
    // Gedrag & Maatschappij - Sociale Wetenschappen & Zorg
    'Social Work',
    'Master Systemisch Werken met Jeugd',
    'Vaktherapie',
    'Master Sport en Bewegingsonderwijs',
    'Jeugdzorg',
    'Human Development',
    'Community Development',
    'Health Care and Social Work',
    // Gedrag & Maatschappij - Sport & Beweging
    'Sport Business & Leadership',
    'Sport en Beweeginnovatie',
    'Performance, Sport and Health',
    'Lichamelijke Opvoeding en Sportpedagogiek',
    // Recht & Bestuur - Bestuur & Veiligheid
    'Master Urban Management',
    'Bestuurskunde',
    'Veiligheid en Digitalisering',
    'Master of Crisis and Public Order Management',
    // Recht & Bestuur - Recht & Juridische Dienstverlening
    'Bedrijfsrecht',
    'Toegepaste Recht',
    'Sociaal Juridische Expert',
    'Master Legal Management',
    // Taal & Communicatie - Communicatie & Media
    'Professional Master in Media Innovation',
    'International Communication Management',
    'International Communication',
    'Strategische Communicatie',
    'Content & Media Strategy',
    // Recht & Bestuur - Algemeen Recht & Rechtsgeleerdheid
    'Nederlands recht',
    'Rechtsgeleerdheid',
    'Privaatrecht',
    'Publiekrecht',
    'Rechtwetenschappelijk Onderzoek',
    // Additional from last section
    'Internationaal Recht',
    'Internationale Betrekkingen',
    'Europees Recht',
    'Ondernemingsrecht',
    'Fiscaal Recht',
    'Milieurecht',
    'Strafrecht',
    'Arbeidsrecht',
    'IT-recht',
    'Gezondheidszorgrecht'
  ]
}
